import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { appendWistiaScriptIfMissing, addVideoToQueue } from './wistiaSdk';
const WistiaVideoPlayer = t0 => {
  const $ = _c(12);
  const {
    options,
    videoId,
    onLoaded
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[1] !== options || $[2] !== videoId) {
    t2 = () => {
      let videoHandle;
      if (videoId) {
        addVideoToQueue({
          id: videoId,
          options,
          onEmbedded: video => {
            videoHandle = video;
          }
        });
      }
      return () => {
        if (videoHandle) {
          videoHandle.remove();
        }
      };
    };
    t3 = [videoId, options];
    $[1] = options;
    $[2] = videoId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== onLoaded || $[6] !== videoId) {
    t4 = () => {
      if (!window._wq) {
        return;
      }
      window._wq.push({
        id: videoId,
        onReady: onLoaded
      });
    };
    t5 = [onLoaded, videoId];
    $[5] = onLoaded;
    $[6] = videoId;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const t6 = `m-0 wistia_embed wistia_async_ ${videoId} videoFoam=true`;
  let t7;
  if ($[9] !== t6 || $[10] !== videoId) {
    t7 = <div className={t6} key={videoId} />;
    $[9] = t6;
    $[10] = videoId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
WistiaVideoPlayer.propTypes = {
  options: PropTypes.object,
  videoId: PropTypes.string.isRequired,
  onLoaded: PropTypes.func
};
export default WistiaVideoPlayer;
function _temp() {
  appendWistiaScriptIfMissing();
}